import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
// import VueResource from 'vue-resource'
import store from '@/store/'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'config/rem'
import App from './App'
import routes from '@/router'
import '@/common/stylus/index.styl'
import FastClick from 'fastclick'
import { getCookie } from '@/common/js/cookies'
// import { loadFromLocal } from '@/common/js/store'

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function() {
      FastClick.attach(document.body)
  }, false)
}

// rem 确保执行顺序优先nextTick
var docEl = document.documentElement
var clientWidth = docEl.clientWidth
docEl.style.fontSize = 50 * (clientWidth / 375) + 'px'

Vue.use(VueRouter)
Vue.use(MintUI)
// Vue.use(VueResource)
Vue.config.productionTip = false
Vue.prototype.apiUrl = '/_data'
// Vue.use(PopupBox)

const router = new VueRouter({
  mode: 'history',
  routes
})

window.Router = router

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    if (getCookie('isLogined')) { // 判断当前的isLogined是否存在
      next()
    } else {
      next({
      path: '/login',
      query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
  // 写在登录路由
  // if (this.$route.query.redirect) {
  //   //  let redirect = decodeURIComponent(this.$route.query.redirect)
  //   let redirect = this.$route.query.redirect
  //   this.$router.push(redirect)
  // } else {
  //   this.$router.push('/')
  // }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js